import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { ProductDetailComponent } from "./product-detail/product-detail.component";
import { SkuDetailComponent } from "./sku-detail/sku-detail.component";


const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "sku/:sku",
        component: SkuDetailComponent,
        data: { title: "SKU Detail" },
      },
      {
        path: "product/:product",
        component: ProductDetailComponent,
        data: { title: "Product" },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SkuDetailRoutingModule {}
